export class ConfirmationEmailRequest {
    public userName: string;
    public userEmail: string;
    public urlPatientCenter: string;
    public isAtivation: boolean;
}